// extracted by mini-css-extract-plugin
export default {"backButton":"BackButtonStyles_backButton__gUqUT"};